import React, { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon } from 'lucide-react';
import { previews } from '../data/previews';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
export function ContentCarousel() {
  const [index, setIndex] = useState(0);
  const total = previews.length;
  const go = (next: number) => setIndex((next + total) % total);
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      go(index + 1);
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      go(index - 1);
    }
  };
  return <section className="bg-paper px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="contenido" data-id="element-35" data-mp="2ynkvq3m6wozk">
      <div className="mx-auto max-w-6xl" data-id="element-36" data-mp="33mfonydvftxe">
        <Reveal data-id="element-37" data-mp="2por4ytvjistx">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-38" data-mp="2pqakujdab1v6">
            <div data-id="element-39" data-mp="2tpjdtm0i2vpo">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-40" data-mp="2tq2yhahjby7e">
                Adentro del pack
              </p>
              <h2 id="contenido" className="display mt-4 max-w-2xl text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-41" data-mp="w15rq6ib1ipq">
                Mirá un poco del contenido que te vas a llevar
              </h2>
            </div>

            <div className="flex shrink-0 items-center gap-3" data-id="element-42" data-mp="15zuzh6ghlms9">
              <button type="button" onClick={() => go(index - 1)} aria-label="Ver plantilla anterior" className="flex h-12 w-12 items-center justify-center rounded-full border border-paper-line text-ink transition-colors duration-150 ease-out hover:border-grass hover:text-grass focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grass" data-id="element-43" data-mp="i8pj8q6mwshf">
                <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-44" data-mp="3qpc09o9bzx86" />
              </button>
              <button type="button" onClick={() => go(index + 1)} aria-label="Ver plantilla siguiente" className="flex h-12 w-12 items-center justify-center rounded-full border border-paper-line text-ink transition-colors duration-150 ease-out hover:border-grass hover:text-grass focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grass" data-id="element-45" data-mp="k8221p0btwzj">
                <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-46" data-mp="1askkdekatkx" />
              </button>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-47" data-mp="aa5qwx7e321f">
          <div className="mt-12 overflow-hidden rounded-2xl border border-paper-line bg-paper-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grass" role="group" aria-roledescription="carrusel" aria-label="Muestras del contenido del megapack" tabIndex={0} onKeyDown={onKeyDown} data-id="element-48" data-mp="a8umqwa17s9s">
            <div className="flex transition-transform duration-300 ease-[cubic-bezier(0.23,1,0.32,1)]" style={{
            transform: `translateX(-${index * 100}%)`
          }} data-id="element-49" data-mp="3b5nc7par12kd">
              {previews.map((preview, i) => <div key={preview.title} className="w-full shrink-0" aria-hidden={i !== index} role="group" aria-roledescription="diapositiva" aria-label={`${i + 1} de ${total}: ${preview.title}`} data-id="element-50" data-mp="2whk0s0dxsyo6" data-mpi={i}>
                  <div className="grid items-center gap-8 p-6 sm:p-8 lg:grid-cols-[0.85fr_1fr] lg:gap-12 lg:p-10" data-id="element-51" data-mp="2iike2y9zitun">
                    <img src={preview.image} alt={preview.alt} loading={i === 0 ? 'eager' : 'lazy'} className="mx-auto max-h-[30rem] w-auto rounded-lg border border-paper-line bg-paper object-contain shadow-xl lg:max-h-[34rem]" data-id="element-52" data-mp="2djpuvv83v3a0" />

                    <div data-id="element-53" data-mp="jpwoybky75je">
                      <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-grass" data-id="element-54" data-mp="ordkrsoks1t4">
                        {preview.count}
                      </p>
                      <h3 className="display mt-3 text-3xl text-ink sm:text-4xl" data-id="element-55" data-mp="9vxm1ad1vhqe">
                        {preview.title}
                      </h3>
                      <ul className="mt-6 space-y-3" data-id="element-56" data-mp="1086hhya9hkx">
                        {preview.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-57" data-mp="5tj5wy0rmw2t">
                            <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-58" data-mp="3s82m909awlbx" />
                            {bullet}
                          </li>)}
                      </ul>
                      <p className="mt-6 text-sm text-ink-dim" data-id="element-59" data-mp="2zn6upyws72ds">
                        Listo para imprimir o abrir en el celular en plena cancha.
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </Reveal>

        <div className="mt-8 flex flex-col items-center gap-8 sm:flex-row sm:justify-between" data-id="element-60" data-mp="33osd1zs348vd">
          <div className="flex items-center gap-3" role="tablist" aria-label="Plantillas" data-id="element-61" data-mp="3ihu85kuv68ex">
            {previews.map((preview, i) => <button key={preview.title} type="button" role="tab" aria-selected={i === index} aria-label={preview.title} onClick={() => go(i)} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grass ${i === index ? 'w-10 bg-grass' : 'w-2.5 bg-ink/20 hover:bg-ink/40'}`} data-id="element-62" data-mp="3rcs30xhknv8w" data-mpi={i} />)}
          </div>

          <CtaButton data-id="element-63" data-mp="32y3sy5f7mgs7">Quiero todas las plantillas</CtaButton>
        </div>
      </div>
    </section>;
}